import Cookies from "js-cookie";

export function getUserFromStorage() {
  try {
    const user = localStorage.getItem("user");
    if (user) {
      return JSON.parse(user);
    }
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
    localStorage.removeItem("user"); // Clean up corrupted data
  }
  return null;
}

export function getToken() {
  const token = Cookies.get("token");
  return token ? token : "";
}

export function isAuthenticatedUser() {
  try {
    const authUser = localStorage.getItem("user");
    return authUser ? true : false;
  } catch (error) {
    console.error("Error checking authentication from localStorage:", error);
    return false;
  }
}

export function getTeamFromCookies() {
  const team = Cookies.get("team");
  return team ? team : null;
}

export function getOutletFromCookies() {
  const outlet = Cookies.get("outlet");
  if (outlet) {
    return JSON.parse(outlet);
  }
}
export function getOutletTypeFromCookies() {
  const outlet_type = Cookies.get("outlet-type");
  return outlet_type;
}
